import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NavigationStart, Router, RouterModule } from '@angular/router';
import { IonicModule, MenuController } from '@ionic/angular';
import { UserFlows } from 'src/app/flows/user.flows';
import { UserService } from 'src/app/shared-lib/domains/user';

@Component({
  selector: 'app-account-menu',
  templateUrl: './account-menu.component.html',
  styleUrls: ['./account-menu.component.scss'],
  imports: [CommonModule, IonicModule, RouterModule]
})
export class AccountMenuComponent implements OnInit {

  @Input() mobileMenu: boolean = false;

  expand: boolean = true;
  accordionValue: string = 'profile';
  onProfile: boolean = false;

  constructor(
    private userFlows: UserFlows,
    public router: Router,
    public userService: UserService,
    private menuController: MenuController
  ) { }

  ngOnInit() {
    this.onProfile = this.router.url.includes('mi-perfil');

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.onProfile = event.url.includes('mi-perfil');
        this.closeAccountMenu();
      }
    });
  }

  doLogout() {
    this.userFlows.doLogout()
      .then(() => this.router.navigate(['']));
    this.closeAccountMenu();
  }

  toggleExpand() {
    this.expand = !this.expand;
  }

  closeAccountMenu() {
    this.menuController.close('account-menu');
  }
}
